import React from 'react';
import PropTypes from 'prop-types';
import { StyledFieldset, Description } from './styles';
import { VisuallyHidden } from '../../styled/accessibility';

const Fieldset = ({
  children,
  legend,
  description,
  hideLegend,
  removeMarginBottom,
}) => (
  <StyledFieldset $removeMarginBottom={removeMarginBottom}>
    {legend &&
      (hideLegend ? (
        <VisuallyHidden as="legend">{legend}</VisuallyHidden>
      ) : (
        <legend>{legend}</legend>
      ))}
    {children}
    {description && <Description>{description}</Description>}
  </StyledFieldset>
);

export const FieldsetPropTypes = {
  children: PropTypes.array,
  legend: PropTypes.string,
  description: PropTypes.string,
  hideLegend: PropTypes.bool,
  removeMarginBottom: PropTypes.bool,
};

Fieldset.propTypes = FieldsetPropTypes;

export default Fieldset;
